import React, { useState } from 'react'
import HoasForm from './HoasForm'
import { useParams } from 'react-router-dom';

const EditHoaPage = () => {
  const { id } = useParams();
  
  
  
  return (
    <>
    currentHoaId?(<HoasForm formType='edit' currentHoaId={id} ></HoasForm>):''
     
    </>
  )
}

export default EditHoaPage
